import { SidebarButton, SidebarNavItem } from "./SidebarNavMenuView";

/**
 * Differentiates between Buttons & NavItems
 *
 * @export
 * @param {(SidebarNavItem | SidebarButton)} sidebarItem
 * @returns {sidebarItem is SidebarNavItem}
 */
export function isSidebarNavItem(sidebarItem: SidebarNavItem | SidebarButton): sidebarItem is SidebarNavItem {
    return sidebarItem && sidebarItem.hasOwnProperty("path");
}
